module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/dpHRtc7Ss7LzQuwx6APHV-263686bf03d9f6c074fc31e7a92fa562.jpg";